module.exports = __webpack_public_path__ + "static/media/marqette.82a3b62a.png";